<template>
  <v-dialog
    v-model="show"
    :max-width="options.maxWidth"
    :transition="transition"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
  >

    <v-card
      style="min-height:500px;"
      column
    >

      <v-toolbar
        dark
        color="primary"
        column
        flat
        style="border-bottom: 1px solid #f5f5f5; background-color:white; margin:0px; padding:0px;"
      >

        <v-toolbar-title>Upload Records</v-toolbar-title>

      </v-toolbar>
      <v-card-text>
        <v-layout column>

          <span style="font-size:18px; font-weight:700;">Record Information</span>
          <v-autocomplete
            hide-selected
            :items="providersToDisplay"
            item-text="displayName"
            :search-input.sync="uploadProviderSearchInput"
            return-object
            class="mt-3"
            outline
            required
            v-model="providerInputValue"
            label="Medical Provider"
          >
            <template slot="no-data">
              <v-list-tile>
                <v-list-tile-title>
                  Search by <strong>Provider Name</strong>
                </v-list-tile-title>
              </v-list-tile>
            </template>
            <template
              slot="item"
              slot-scope="{ item, tile }"
            >
              <v-list-tile-avatar>
                <v-icon
                  v-if="item.icon"
                  color="primary"
                  style="background-color: #eeeeee"
                >{{item.icon}}</v-icon>
                <v-icon
                  v-else
                  color="primary"
                  style="background-color: #eeeeee"
                >person</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-text="item.displayName"></v-list-tile-title>
                <v-list-tile-sub-title v-text="item.displayLocale"></v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
          <v-layout row>
            <v-flex xs8>
              <v-select
                :items="recordTypes"
                class="mr-2"
                outline
                required
                v-model="typeInput"
                label="Record Type"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                outline
                hint="mm/dd/yyyy"
                mask="##/##/####"
                persistent-hint
                v-model="dateInput"
                label="Record Date"
              ></v-text-field>
            </v-flex>
          </v-layout>

        </v-layout>
        <v-card
          flat
          style="background-color:#eeeeee; border-radius:4px; cursor:pointer;"
          class="dropzone"
          mb-4
        >
          <vue-dropzone
            :useCustomSlot=true
            style="width:100%; border:0px; background-color:transparent;"
            ref="dropzone"
            @vdropzone-files-added="filesAdded"
            @vdropzone-queue-complete="allFilesCompleted"
            @vdropzone-sending="changeURL"
            @vdropzone-error="errorOccured"
            id="dropzone"
            :options="dropzoneOptions"
          >
            <v-container
              fill-height
              class="dropzone-custom-content ma-0"
            >
              <v-layout
                justify-center
                column
              >
                <v-layout row>
                  <v-spacer>
                    <v-icon
                      style="border-radius:50%; height:80px; width:80px; border: 4px solid #999999;"
                      x-large
                    >cloud_upload</v-icon>
                  </v-spacer>
                </v-layout>
                <v-layout
                  class="mx-2"
                  row
                >
                  <v-spacer>
                    <div style="margin-top:5px; opacity:0.6;">
                      <p>Click to choose a PDF to upload or drag and drop your file here</p>
                    </div>
                  </v-spacer>
                </v-layout>
              </v-layout>
            </v-container>
          </vue-dropzone>
        </v-card>
      </v-card-text>
      <v-spacer></v-spacer>

      <v-card-actions class="px-3 pb-3">

        <v-btn
          depressed
          @click="close"
        >Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="submitFiles()"
          depressed
        >Upload</v-btn>

      </v-card-actions>
    </v-card>

    <div id="tpl">
      <div
        class="dz-preview dz-file-preview well"
        id="dz-preview-template"
      >
        <div class="dz-details">
          <div class="dz-filename"><span data-dz-name></span></div>
          <div
            class="dz-size"
            data-dz-size
          ></div>
        </div>
        <div class="dz-progress"><span
            class="dz-upload"
            data-dz-uploadprogress
          ></span></div>
        <div class="dz-success-mark"><span></span></div>
        <div class="dz-error-mark"><span></span></div>
        <div class="dz-error-message"><span data-dz-errormessage></span></div>
      </div>
    </div>

  </v-dialog>
</template>

<style scoped>
.card > .card__actions {
  flex: none;
}

.card__actions .btn {
  text-transform: capitalize;
}

.building {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.standardCard {
  border: 1px solid #e6e6e8;
  background-color: white;
}

.title {
  font-size: 24px;
  font-weight: 300;
  line-height: 1.33;
  text-align: center;
  color: white;
}
</style>

<script>
import DialogMixin from '@/core/mixins/DialogMixin'
import HelperMixin from '@/core/mixins/HelperMixin'
import { mapState, mapActions } from 'vuex'
import bus from '@/core/helpers/bus'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'UploadRecordsDialog',
  mixins: [DialogMixin, HelperMixin],
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      recordTypes: [
        'PRE_OP_NOTE',
        'POST_OP_NOTE',
        'OP_NOTE',
        'OFFICE_VISIT',
        'MESSAGE',
        'MRI',
        'IMAGE_READ',
        'XRAY',
        'OTHER_IMAGING',
        'LAB_RESULT',
        'PROGRESS_NOTE',
        'DIAGNOSTIC_REPORT',
        'REFERRAL',
        'COMPLETED_PRIOR_AUTH'
      ],
      providerIDForSubmission: null,
      providersToDisplay: [],
      providerInputValue: '',
      dateInput: '',
      typeInput: 'OFFICE_VISIT',
      uploadProviderSearchInput: null,
      searchType: { title: 'Individuals', value: 'idv' },
      searchTypes: [
        { title: 'Individuals', value: 'idv' },
        { title: 'Organization', value: 'org' }
      ],
      dropzoneOptions: {
        url: 'google.com',
        method: 'put',
        headers: { 'Access-Control-Allow-Origin': '*' },
        thumbnailWidth: '100',
        thumbnailHeight: '100',
        autoProcessQueue: false,
        timeout: 500000,
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>UPLOAD ME",
        acceptedFiles: '.pdf'
      },
      files: null,
      uploadQ: [],
      errorList: []
    }
  },
  computed: {
    ...mapState('provider', ['searchResults']),
    ...mapState('patient', ['patient']),
    ...mapState('auth', ['currentUserGroups']),
    ...mapState('upload', ['uploadInfo', 'uploadPatientURL']),
    transition() {
      return this.$vuetify.breakpoint.xsOnly
        ? 'dialog-bottom-transition'
        : 'scale-transition'
    },
    showBuilding() {
      return this.options.unit && this.options.building
    }
  },
  mounted() {
    this.$on('open', this.onOpen)
  },
  methods: {
    ...mapActions('patient', ['getPatient']),
    ...mapActions('auth', ['getUserGroups']),
    ...mapActions('provider', [
      'search',
      'getProviderIDFromNPI',
      'multipleShareFiles',
      'getProviderAuth'
    ]),
    ...mapActions('upload', [
      'getUploadInfo',
      'getPatientUploadURL',
      'initUploadGoogleStorage',
      'uploadFile',
      'getUploadFailPosition',
      'resumeUpload'
    ]),
    formatDate(timestamp) {
      return this.getBirthdateStringFromTimestamp(timestamp)
    },
    bestGuessProvider() {
      // this method will get any provider associated with the user
      // and insert that provider into the medical provider list.
      // it should fetch the first member of the care team if the user is not associated with anybody.
      this.getUserGroups()
    },
    uploadFiles() {
      // must get the file ids.
      console.log(this.providerIDForSubmission)
      let theDateToUse = this.unixDate(this.dateInput)
      console.log(theDateToUse)
      console.log(this.typeInput)
    },
    unixDate(date) {
      if (date !== '') {
        const formatDate =
          date.slice(4, 8) + '.' + date.slice(0, 2) + '.' + date.slice(2, 4)
        // Format: '2012.08.10'
        return new Date(formatDate).getTime() / 1000
      }
    },
    close() {
      this.providersToDisplay = []
      this.providerInputValue = ''
      this.uploadProviderSearchInput = null
      this.files = null
      this.$refs.dropzone.removeAllFiles()
      this.cancel()
    },
    onOpen() {
      this.recipients = []
      this.emails = []
      this.providers = []
      this.careTeamOptions = []
      this.bestGuessProvider()
      let today = new Date()

      let todayStamp = today.getTime() / 1000
      this.dateInput = this.formatDate(todayStamp)
    },
    toast(type, text) {
      bus.$emit('toast', { type, text })
    },
    changeURL(file, xhr) {
      console.log(
        'changing the url, so in theory we are moving on to the next one'
      )
      this.uploadQ.shift()
      this.$refs.dropzone.setOption('url', this.uploadQ[0])

      let _send = xhr.send
      xhr.send = () => {
        _send.call(xhr, file)
      }
    },
    fileAdded(file) {
      const patient = this.$route.params.id
      console.log()
      console.log(patient)
      // Rendering provider, optional
      // Encounter date, optional
      // Record Type, optional
      // Mimetype
      let mimetype

      if (!(patient && file)) {
        return
      } else {
        mimetype = file.type
      }
      // renderingProvider: null, encounterDate: null, recordType: null,
      this.getPatientUploadURL({
        patient,
        renderingProvider: this.providerIDForSubmission,
        encounterDate: this.unixDate(this.dateInput),
        recordType: this.typeInput,
        mimetype
      }).then(data => {
        this.initUploadGoogleStorage({
          url: data.url,
          type: file.type
        }).then(data => {
          let headers = Array.from(data.headers.entries())

          let locationToPass = ''

          for (let item of data.headers.entries()) {
            if (item[0] === 'location') {
              locationToPass = item[1]
              break
            }
          }
          console.log('data returned from init')
          console.log(headers)
          this.uploadQ.push(locationToPass)
          console.log('adding something to upload q')
          console.log(this.uploadQ)
          this.errorList.push({ file, url: locationToPass })
        })
      })
    },
    allFilesCompleted() {
      this.close()
      this.toast('success', 'Files Uploaded')
    },
    filesAdded(files) {
      for (let i = 0; i <= files.length; i++) {
        this.fileAdded(files[i])
      }
    },
    submitFiles() {
      const dropzone = this.$refs.dropzone

      if (this.optionalDescription) {
        for (let file of this.$refs.dropzone.dropzone.files) {
          file.description = this.optionalDescription
        }
      }

      if (this.uploadQ.length > 0) {
        console.log('upload submitted')
        console.log(this.uploadQ)
        dropzone.setOption('url', this.uploadQ[0])
        dropzone.processQueue()
      }
    },
    errorOccured(file, message, xhr) {
      let errorObj = this.errorList.filter(obj => {
        return obj.file === file
      })
      errorObj = errorObj[0]
      if (errorObj) {
        this.getFailPosition(errorObj)
      } else {
        console.log('failed to find object')
      }
    },
    getFailPosition(errorObj) {
      this.getUploadFailPosition({
        url: errorObj.url,
        uploadSize: errorObj.file.size
      }).catch(error => {
        let range = 0
        if (error.response.status === 308) {
          range = error.response.headers.range
          range = parseInt(range.split('-')[1]) + 1

          errorObj.file.status = 'queued'
          errorObj.file.accepted = undefined
          this.$refs.dropzone.removeFile(errorObj.file)
          this.$refs.dropzone.addFile(errorObj.file)
          this.$refs.dropzone.setOption('url', errorObj.url)
          this.$refs.dropzone.setOption('Content-Length', errorObj.file.size)
          this.$refs.dropzone.setOption('Content-Range', range)

          this.$refs.dropzone.processQueue()
        }
      })
    }
  },
  watch: {
    currentUserGroups(val) {
      console.log('currentUserGroups')
      let ids = []

      val.groups.forEach(group => {
        if (group.provider) {
          // go get the provider information.
          ids.push(group.provider)
        }
      })

      if (ids.length > 0) {
        this.providersToDisplay = []
        this.getProviderAuth({ ids: ids }).then(providersList => {
          providersList.forEach(provider => {
            let displayName = this.providerDisplayNameFromProviderObject(
              provider
            )

            let id = provider._id
            if (this.providerInputValue === '') {
              this.providerInputValue = { displayName: displayName, id: id }
              this.providerIDForSubmission = id
            }
            this.providersToDisplay.push({
              displayName: displayName,
              id: id,
              icon: 'local_hospital'
            })
          })
        })
      }
    },
    providerIDForSubmission(val) {
      console.log('setting provideridforsubmission')
      console.log(val)
    },
    providerInputValue(val) {
      console.log('updated doc')
      console.log(val)
      let selection = val
      // set the id of the doc. if the provider input is an object that already contains one of our ids, just set the id. if not, fetch the id.
      if (selection.id) {
        this.providerIDForSubmission = selection.id
      } else {
        // go fetch the id from our system using the npi
        this.getProviderIDFromNPI({ npis: [val.npi] }).then(providerReturn => {
          let providerReturned = providerReturn[0]
          console.log('returned provider from back end')
          console.log(providerReturned)
          if (providerReturned) {
            console.log('only if provider returned is correct')
            this.providerIDForSubmission = providerReturned._id
            console.log(this.providerIDForSubmission)
          }
        })
      }
    },
    uploadProviderSearchInput(val) {
      this.search({ type: 'individual', terms: val })
    },
    searchResults(val) {
      val.forEach(element => {
        this.providersToDisplay.push(element)
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/UploadFilesDialog.vue